import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@diggens/api-client';
import type { Lesson } from '@diggens/types';

/** What GET /academy/lessons/:attemptId returns: the lesson and where it sits in the learner's track. */
export interface LessonResponse {
  lesson: Lesson;
  kind: string;
  module: string | null;
  track: string | null;
  position: { index: number; count: number };
  sent_at: string | null;
}

export const lessonQueryKey = (attemptId: string) => ['academy', 'lesson', attemptId] as const;

export function useLesson(attemptId: string) {
  return useQuery({
    queryKey: lessonQueryKey(attemptId),
    queryFn: () => apiFetch<LessonResponse>(`/academy/lessons/${encodeURIComponent(attemptId)}`),
    retry: false,
  });
}
